// ------------------ ABOUT PAGE DATA ------------------
export const aboutData = {
  subtitle: "OUR IDENTITY",
  title: "WHO WE ARE",
  desc1:
    "Pestel & Partners is a multidisciplinary financial advisory and consulting firm that delivers integrated solutions in audit, assurance, tax, HUMAN RESOURCES; LEGAL; STRATEGY; corporate finance, and risk management. We support organizations across sectors to enhance financial reporting accuracy, operational efficiency, and governance standards. Our teams combine data analytics, regulatory expertise, and market insight to help businesses make informed decisions, strengthen compliance frameworks, and accelerate growth in an evolving economic landscape.",
  desc2:
    "Every engagement at Pestel & Partners is rooted in strategic insight and ethical precision. From guiding mergers and acquisitions to advising on cross-border taxation, capital structuring, and performance improvement, we bring measurable value to every client's partnership. Our commitment is simple: to build trust, transform financial performance, and empower organizations to lead with confidence in an increasingly complex world.",
};

// ------------------ SERVICES PAGE DATA ------------------
export const servicesData = {
  subtitle: "TECHNOLOGY IN OUR AUDITS",
  title: "Smart Audits Powered by Data & Innovation",
  desc1:
    "We integrate advanced audit tools, analytics, and automation into every engagement to deliver precise, efficient, and insightful results. Our technology-driven approach minimizes errors, identifies trends, and uncovers opportunities for process improvement.",
  desc2:
    "Our technology-driven approach minimizes errors, identifies trends, and uncovers opportunities for process improvement. We integrate advanced audit tools, analytics, and automation into every engagement to deliver precise, efficient, and insightful results.",
};

// ------------------ INDUSTRIES DEFAULT ------------------
export const industriesData = {
  title: "Navigating Complex Investment Landscapes",
  desc1:
    "In today's rapidly evolving financial markets, asset management requires sophisticated strategies and deep expertise. The complexity of global investment environments demands partners who understand both traditional fundamentals and emerging opportunities.",
  desc2:
    "Our comprehensive approach combines decades of experience with cutting-edge analytics to deliver superior risk-adjusted returns while maintaining the highest standards of fiduciary responsibility.",
};

// ------------------ EXISTING INDUSTRY SPECIFIC DATA ------------------
export const oilAndGasData = {
  title: "FINANCIAL BACKBONE BEHIND ENERGY’S TOUGHEST CALLS",
  desc1:
    "In an environment where a single market shift can redraw investment priorities overnight, the oil and gas sector cannot rely on conventional decision-making. Every change in pricing, policy, or geopolitical balance reshapes the financial story companies must respond to. Pestel & Partners brings discipline to this uncertainty by applying scenario-driven financial modelling, asset-level value diagnostics, and intelligent cost-structure refinement.",
  desc2: "",
};

export const powerAndUtilitiesData = {
  title: "FINANCIAL FORESIGHT FOR A MORE ELECTRIFIED WORLD",
  desc1:
    "The power and utilities sector is navigating rapid change as electricity demand grows, renewable sources expand, and ageing grids struggle to keep up. Companies are under pressure to upgrade networks, manage rising operational costs, and stay compliant with evolving regulations. That’s where Pestel & Partners steps in! We help utilities bring structure and clarity to this complexity through detailed financial modelling, tariff analysis, grid investment planning, and performance insights.",
  desc2: "",
};

export const wasteManagementData = {
  title: "SUPPORTING SMARTER WASTE SYSTEMS",
  desc1:
    "Mountains of waste are growing faster than cities can adapt, and the global push for cleaner, circular systems is no longer optional—it’s urgent. The waste management industry is being reshaped by rising volumes, tightening environmental regulations, and the increasing cost of collection, processing, and disposal. Providers are expected to innovate while keeping operations financially viable. Pestel & Partners steps in with strategic financial planning, cost-optimization frameworks, regulatory navigation, and performance insights that help organizations stay ahead of these pressures.",
  desc2: "",
};

export const miningAndMineralsData = {
  title: "UNLOCKING VALUE ACROSS THE MINING ECOSYSTEM",
  desc1:
    "Tomorrow’s mining sector depends on smarter planning, cleaner operations, and better financial judgment. Companies are now expected to deliver steady output while managing ESG goals, digital upgrades, and unpredictable market cycles. Pestel & Partners works closely with mining teams to simplify this complexity—building reliable cost structures, improving asset visibility, and shaping long-term strategies that protect value and strengthen performance.",
  desc2: "",
};

export const assetManagementData = {
  title: "THE FUTURE OF ASSET MANAGEMENT, SIMPLIFIED",
  desc1:
    "Not every asset tells its real story on a balance sheet—and that’s exactly where modern asset management is evolving. Clients want more than return projections; they want transparency, risk clarity, and a strategy that adapts to real-time market behavior. At Pestel & Partners, we help asset managers build portfolios that are resilient, data-aware, and aligned with long-term value creation.",
  desc2:
    "By blending behavioral insights, performance analytics, and forward-looking financial modelling, we support firms in making confident decisions, strengthening client trust, and managing assets with precision in an increasingly unpredictable investment environment.",
};

export const bankingData = {
  title: "BANKING THAT MOVES WITH THE MARKET",
  desc1:
    "The real story of banking today isn’t written in balance sheets – it’s written in how quickly institutions respond to risk, regulation, and rapidly shifting customer expectations. Markets move fast, compliance frameworks tighten every quarter, and digital competitors continue raising the bar for efficiency and trust.",
  desc2:
    "At Pestel & Partners, we help banks move with this pace by strengthening capital strategy, modernizing core operations, tightening controls, and shaping customer experiences that inspire long-term loyalty.",
};

// ------------------ NEW FINANCIAL INDUSTRY PAGES ------------------
export const financialAdvisoryData = {
  title: "ADVISORY THAT MOVES DECISIONS FORWARD",
  desc1:
    "Financial clarity often starts long before the numbers are reviewed—it begins when leaders ask the right questions and understand the story behind each financial decision. In a market shaped by uncertainty, shifting valuations, and rapid regulatory changes, organizations need advisors who translate complexity into clear, confident action.",
  desc2:
    "Pestel & Partners brings the same! Our disciplined analysis, market intelligence, and strategic foresight help businesses strengthen capital decisions, manage financial risks, and shape long-term value with conviction.",
};

export const financialServicesTaxData = {
  title: "GUIDING SMARTER TAX DECISIONS",
  desc1:
    "Tax complexity often rises faster than businesses can adapt, creating real pressure around compliance, reporting accuracy, and strategic planning. Instead of treating tax as a routine obligation, leaders today view it as a financial decision point that shapes profitability, risk, and long-term stability.",
  desc2:
    "Let Pestel & Partners handle this! We simplify regulatory noise, strengthen governance, and help organizations build tax strategies that are efficient, transparent, and aligned with evolving global standards. All while staying practical for everyday operations.",
};

export const fintechData = {
  title: "ADVANCING THE FINTECH FRONTIER",
  desc1:
    "FinTech succeeds when innovation and financial discipline move in sync—something many fast-growing platforms struggle to maintain. With customer expectations rising and regulators demanding greater transparency, FinTech companies need strategies rooted in real-world rigor, not experimentation alone.",
  desc2:
    "Pestel & Partners brings that balance, aligning digital innovation with profitability, compliance, and long-term performance to help FinTech leaders scale with confidence.",
};

export const insuranceData = {
  title: "FINANCIAL INTELLIGENCE FOR INSURERS",
  desc1:
    "Insurance today is shaped by rising risks, evolving regulations, and customers who expect faster, clearer, more transparent protection. As margins tighten and reporting demands increase, insurers must modernize underwriting, improve capital efficiency, and strengthen their financial frameworks.",
  desc2:
    "Here we are for all those insurers! At Pestel & Partners, we support insurers with practical, data-driven strategies that enhance operational accuracy, streamline compliance, and create sustainable value across the entire insurance lifecycle.",
};

// ------------------ NEW INDUSTRIES YOU PROVIDED ------------------
export const healthcareData = {
  title: "BUILDING BETTER HEALTH ECOSYSTEMS",
  desc1:
    "Healthcare today is shaped by rising patient expectations, tighter cost pressures, and the ongoing need for digital transformation, yet real change happens only when financial clarity and operational strength work together. Providers modernize workflows, improve access, and manage regulatory demands while keeping care compassionate and efficient. Pestel & Partners help healthcare leaders bring structure to complexity, uncover performance gaps, and build smarter systems that deliver sustainable growth and better patient experiences.",
  desc2: "",
};

export const lifeScienceData = {
  title: "SHAPING THE FUTURE OF LIFE SCIENCES",
  desc1:
    "Innovation in life sciences rarely follows a straight line; teams must balance research timelines, patient expectations, cost pressures, and strict global regulations all at once. The real challenge isn’t discovery but sustaining it. Hence, Pestel & Partners delivers it! We help organizations strengthen financial clarity, streamline compliance, and build strategies that bring promising science to the people who need it most.",
  desc2: "",
};

export const privateEquityData = {
  title: "SHARPER DECISIONS. STRONGER RETURNS.",
  desc1:
    "Private equity thrives on timing, clarity, and disciplined value creation—but today’s landscape demands more than capital. Firms must navigate volatile valuations, shifting regulatory expectations, and rising pressure to deliver measurable operational improvements. At Pestel & Partners, we help funds move confidently across the investment cycle with sharper financial insights, cleaner deal assessments, and post-acquisition strategies designed to accelerate value in the first 100 days and beyond.",
  desc2: "",
};

export const professionalServiceData = {
  title: "STRENGTHENING PROFESSIONAL EXCELLENCE",
  desc1:
    "Pressure inside professional services has never been higher. Leaders are now expected to deliver clear financial visibility, tighter operational control, and teams that can scale without sacrificing quality. Yet gaps in utilization, fragmented delivery workflows, and slow digital adoption often hold firms back from the performance they know they can achieve. Pestel & Partners ease this! They work with professional service organizations to strengthen their operating models, elevate delivery excellence, and unlock revenue clarity.",
  desc2: "",
};

export const publicSectorData = {
  title: "TRANSFORMING HOW PUBLIC SYSTEMS WORK",
  desc1:
    "Public institutions today operate in an environment where every inefficiency is felt immediately—service queues grow longer, budgets stretch thinner, and citizens expect faster, more transparent delivery. Aging systems, fragmented data, and slow decision cycles make it difficult for governments to keep pace with real-world demands. That’s where Pestel & Partners steps in! We work with governments to rebuild system strength and modernize digital infrastructure that delivers reliable services and long-term institutional resilience.",
  desc2: "",
};

export const realEstateConstructionData = {
  title: "REAL ESTATE & CONSTRUCTION WITHOUT CHAOS",
  desc1:
    "Projects don’t fail because of one big issue; they fall apart through a thousand small ones. In today’s real estate & construction landscape, these micro-breakdowns add up fast, turning predictable plans into volatile outcomes. Leaders need more than dashboards; they seek visibility that exposes the root causes behind overruns and delays. Here, Pestel & Partners can be your partner! We help firms strengthen financial discipline, tighten delivery governance, modernize digital workflows, and restore predictability.",
  desc2: "",
};
export const mediaAndEntertainmentData = {
  title: "BUILDING HIGH-IMPACT MEDIA BUSINESSES",
  desc1:
    "The biggest challenge in entertainment today isn’t creating content; it’s knowing which content will break through the noise. With rising costs and unpredictable audience behavior, instinct alone can’t steer the business. To survive this pace, media companies need sharper insight into what works and why. Pestel & Partners helps media leaders make smarter investments, optimize performance, and build content strategies built for the digital-first future.",
  desc2: "",
};

export const technologyData = {
  title: "THE FUTURE OF TECHNOLOGY PERFORMANCE",
  desc1:
    "The technology sector moves faster than any other part of TMT—product cycles shrink, customer expectations rise, and competition emerges overnight. Most teams don’t struggle with ideas—they struggle with identifying which innovations can truly scale. Pestel & Partners helps technology companies simplify complexity, sharpen product focus, and build systems that transform innovation into profitable, long-term growth.",
  desc2: "",
};

export const telecommunicationData = {
  title: "DESIGNING RESILIENT TELECOM SYSTEMS",
  desc1:
    "Telecom today operates under constant strain—costly network upgrades, price-sensitive customers, and pressure to deliver flawless service every minute. Operators navigate high capital expenditure, strict regulations, and competitive saturation. Pestel & Partners supports telecom leaders with strategies that stabilize margins, modernize operations, and build the strong connectivity models today’s markets demand.",
  desc2: "",
};
// FINANCIAL STATEMENT AUDIT
export const financialStatementAuditData = {
  subtitle: "BEYOND COMPLIANCE",
  title: "TURNING YOUR AUDIT INTO A STRATEGIC ADVANTAGE",
  desc1:"Financial audits are no longer about checking boxes – they shape investor trust, influence valuations, and reveal operational blind spots that internal teams often miss. When audit findings translate into strategic decisions, businesses gain clarity on cost leakages and efficiency gaps. ",
  desc2: "With Pestel & Partners, your audit evolves into a forward-looking tool. We highlight improvement opportunities, benchmark your controls against industry maturity, and bring data-backed insights that strengthen board reporting and financial governance. ",
};

// IFRS ADVISORY SERVICE
export const ifrsAdvisoryServiceData = {
  subtitle: "CREATING LONG-TERM REPORTING",
  title: "BUILDING IFRS-READY ORGANIZATIONS",
  desc1:
    "IFRS compliance is not a one-time exercise; it evolves with every market shift, standard update, and business transaction. We help organizations build resilient reporting systems that stay aligned with global expectations and support future growth.",
  desc2:
    "With Pestel & Partners, you gain more than technical support. You gain a strategic partner who strengthens financial clarity, enhances transparency, and elevates reporting maturity year after year.",
};

// OTHER ASSURANCE SERVICE
export const otherAssuranceServiceData = {
  subtitle: "WHY ASSURANCE MATTERS",
  title: "WE STRENGTHEN THE TRUST BEHIND EVERY DECISION YOU MAKE",
  desc1:
    "Numbers tell a story, but only assurance makes it credible. When stakeholders question performance, ESG promises, or internal reporting, confidence comes not only from data, but also from the strength behind it.",
  desc2:
    "Working with Pestel & Partners means working with auditors who look beyond checklists and into the real mechanics of your business. We don’t just verify — we reveal, strengthen, and defend the information that powers strategic decisions. If your business is ready for confidence grounded in evidence, we’re prepared to lead the way.",
};

// INTERNAL CONTROL FRAMEWORK
export const internalControlFrameworkData = {
  subtitle: "FUTURE-READY CONTROL ARCHITECTURE",
  title: "PROTECTING THE BUSINESS YOU BUILD TODAY",
  desc1:
    "Internal controls are not just defense mechanisms; they are the backbone of business continuity. When controls are strong, decisions move faster, reporting becomes reliable, and leaders operate with confidence instead of caution.",
  desc2:
    "Pestel & Partners helps organizations replace guesswork with governance maturity. If you are scaling, transforming, digitizing or preparing for investor scrutiny, it's time your control framework evolved with you, not after the risk appears, but before.",
};

export const dealAdvisoryData = {
  subtitle: "YOUR DEAL SHOULD CREATE TOMORROW",
  title: "LET’S BUILD TRANSACTIONS THAT TURN INTO MOMENTUM",
  desc1:
    "Good deals don’t end at signing. The real story starts after integration. That’s where judgment, readiness, and strategic clarity matter. At Pestel & Partners, we help businesses navigate acquisitions, divestments, capital raises, mergers, and joint ventures with logic, discipline, and future-growth thinking.",
  desc2:
    "Our team steps in as strategy partners and mapS post-deal value creation from Day 1. If you're planning a deal, preparing for one, or deciding whether to walk away, we help you move with sharper insight, stronger negotiation power, and complete confidence.",
};
export const restructuringData = {
  subtitle: "RESTRUCTURING WITH STRATEGY",
  title: "TRANSFORMING FINANCIAL STRESS INTO A STRUCTURED PLAN",
  desc1:
    "Cash strain, lender pressure, and operational slowdowns don’t resolve with hope; they resolve with structure, visibility, and tough decisions made early. Pestel & Partners helps leadership regain control, prioritize what must change first, and stabilize the business before rebuilding growth levers.",
  desc2:
    "If your organization is at a turning point — decline, debt, disruption or transition — we bring the clarity, negotiation strength and execution control needed to move forward with confidence.",
};
export const dueDiligenceData = {
  subtitle: "CLARITY THAT PROTECTS CAPITAL",
  title: "WHEN MONEY MOVES, EVIDENCE MUST MOVE FIRST",
  desc1:
    "A deal collapses when unknown risks appear later. Our role is to make sure nothing remains “unknown.” If you’re preparing to acquire, invest, or merge; you need a view that cuts through narratives and exposes truth. That’s where we step in.",
  desc2:
    "With Pestel & Partners, decisions are sharper, confidence is real, and capital is defended — not hoped for.",
};
export const forensicServicesData = {
  subtitle: "FRAUD COST IS SILENT",
  title: "THE RIGHT TIME TO INVESTIGATE IS BEFORE DAMAGE GROWS",
  desc1:
    "Fraud rarely announces itself; its early signs are subtle: delays in reporting, unexplained adjustments, vendor inconsistencies, or unusual cash movements. Acting early protects capital, reputation and governance.",
  desc2:
    "A clean business isn't one without fraud — it's one that detects it, proves it and prevents it effectively. Let’s bring clarity to uncertainty, with evidence that speaks louder than assumptions.",
};
export const riskAdvisoryData = {
  subtitle: "RISK DOESN’T WAIT",
  title: "SAFEST COMPANIES ALWAYS PREPARE EARLY",
  desc1:
    "Risk exists everywhere — in systems, people, decisions and markets. What differentiates a resilient organization is preparedness, foresight and the willingness to fix before failure occurs.",
  desc2:
    "A strong risk structure protects cash, credibility and continuity. Let’s design one that keeps your business ahead, even when the environment isn’t predictable.",
};
export const technologyAdvisoryServiceData = {
  subtitle: "DIGITAL DECISIONS DEFINE TOMORROW",
  title: "LET’S BUILD TECHNOLOGY THAT MOVES YOUR BUSINESS FORWARD",
  desc1:
    "Transformation isn’t just about new software; it’s about smarter systems, clearer decisions and operations that run without friction or delay. When technology strengthens every business function, growth becomes scalable rather than stressful.",
  desc2:
    "If your organization is planning a digital upgrade or facing tech inefficiencies, our advisory team can turn uncertainty into a roadmap, and investment into lasting performance.",
};
export const valuationsData = {
  subtitle: "WHY ORGANIZATIONS TRUST US",
  title: "VALUATIONS THAT REDUCE DOUBT AND DRIVE ACTION",
  desc1:
    "Valuation influences decisions that shape ownership, investment & future strategy, and accuracy matters. Our reports do more than calculate worth; they provide rationale, evidence, scenario views and negotiation clarity.",
  desc2:
    "Businesses rely on us when valuation must be defendable, transparent, and commercially grounded — a number that helps them move forward, not question what's next.",
};

// TAXATION DATA ARRAYS

export const corporatetaxData = {
  subtitle: "TAX CONFIDENCE STARTS WITH STRATEGY",
  title: "LET’S BUILD A TAX ECOSYSTEM THAT PROTECTS VALUE",
  desc1:
    "A strong tax framework reduces uncertainty, reassures investors and strengthens governance, and we help you build it with clarity, speed & foresight. Your returns shouldn’t just be filed; they should be defensible, optimised and ready for scrutiny anytime.",
  desc2:
    "Partner with Pestel & Partners to make taxation predictable, powerful and profitable — year after year.",
};

export const mergerandacquisitionData = {
  subtitle: "SCALE WITH CERTAINTY",
  title: "TAX INTELLIGENCE THAT STRENGTHENS EVERY TRANSACTION",
  desc1:
    "A merger can unlock markets, talent and scale, but poorly managed taxation can dilute the value just as fast. We bridge strategy with tax foresight, ensuring every deal you sign protects your interests, strengthens your balance sheet, and delivers measurable returns.",
  desc2:
    "Expanding globally, acquiring assets, consolidating units, or restructuring operations - demands precision. Our team partners with you end-to-end, aligning tax efficiency with deal ambition, so your next transaction fuels growth instead of risk.",
};

export const transferpricingData = {
  subtitle: "FUTURE-READY TAX STRUCTURES",
  title: "YOUR GLOBAL VALUE CHAIN, PROTECTED & COMPLIANT",
  desc1:
    "Regulators today demand storytelling through data — who creates value, who takes risk, where profit should reside. A robust TP model is no longer optional, it is survival architecture.",
  desc2:
    "We help businesses document reality, defend pricing, and move confidently across jurisdictions. This is not paperwork; it is long-term tax safety, profit stability, and strategic credibility.",
};

export const valueaddedtaxData = {
  subtitle: "WHY IT MATTERS",
  title: "VAT SHOULD SAVE COST – NOT CREATE RISK",
  desc1:
    "VAT is one of the few taxes that impacts daily business rhythm, including pricing, cashflow, vendor selection and reporting. When structured well, it protects margins and reduces operational friction. When handled loosely, it escalates into penalties, credit loss, and avoidable disputes.",
  desc2:
    "We don’t just file VAT. We engineer certainty.",
};

export const internationaltaxData = {
  subtitle: "LET’S BUILD BORDERLESS GROWTH",
  title: "YOUR INTERNATIONAL TAX JOURNEYS NEEDS MORE THAN COMPLIANCE",
  desc1:
    "Global expansion shouldn’t feel like navigating blindfolded. With Pestel & Partners, you gain clarity, control, and a tax structure engineered for scale.",
  desc2:
    "We become your extended tax arm—guarding compliance, reducing leakages, and helping you move capital confidently across borders.",
};

export const excisetaxData = {
  subtitle: "MOVE FORWARD WITH CERTAINTY",
  title: "YOUR EXCISE TAX BURDEN, MANAGED WITH STRATEGY",
  desc1:
    "Excise isn’t just a statutory cost — it influences pricing, margins and supply chain movement. When handled strategically, compliance becomes a competitive advantage rather than an administrative burden.",
  desc2:
    "Our team empowers you with clarity, control and compliance confidence. No ambiguity. No last-minute rush. Just tax governance designed to scale with your growth and secure your bottom line.",
};

export const taxrestructuringData = {
  subtitle: "SMARTER TAX ECOSYSTEMS",
  title: "RESTRUCTURING THAT STRENGTHENS PROFIT, NOT RISK",
  desc1:
    "A good tax structure protects profits. A great one accelerates expansion, simplifies operations and reduces uncertainty. With us, tax restructuring becomes a planned growth strategy, not a reactive correction.",
  desc2:
    "We deliver structures built to endure regulatory changes, scale with business growth and maximize long-term value creation.",
};

export const economicsubstanceregulationsData = {
  subtitle: "STAY COMPLIANT. STAY CONFIDENT.",
  title: "ESR ISN’T OPTIONAL, IT’S STRATEGIC",
  desc1:
    "Economic substance is now a business obligation, but with the right structure, it also becomes a strength. We help organizations document their reality clearly, prove decision control, and operate confidently without regulatory shocks.",
  desc2:
    "With our guidance, ESR becomes simple, repeatable and sustainable year after year — not a rushed deadline activity. Your compliance is safeguarded; your business runs uninterrupted.",
};
export const financeAndAccountingData = {
  subtitle: "CLOSER THAN AN OUTSOURCING PARTNER",
  title: "YOUR FINANCE OFFICE – JUST NOT INSIDE YOUR OFFICE",
  desc1:
    "When finance is outsourced to the right partner, it doesn’t feel external. Reports arrive on time, books stay compliant, decisions move faster, and leadership focuses on growth instead of reconciling spreadsheets.",
  desc2:
    "Our goal is simple: build a financial ecosystem where operations flow naturally, numbers reflect reality, and the business always knows where it stands and where it’s going. If you're looking for finance that works proactively - we’re ready to step in.",
};

export const corporateAdvisoryServicesData = {
  subtitle: "YOUR ADVISORS BEYOND CONSULTATION",
  title: "WE HELP YOU THINK BIGGER, EXECUTE BETTER",
  desc1:
    "The right advisory partner doesn’t replace leadership — it strengthens it. With deeper insight, structured financial thinking, and a tested market perspective, organizations make decisions that stand firm against volatility.",
  desc2:
    "If your business is entering a new phase, such as expansion, restructuring, acquisition or capital planning — this is where strategic clarity matters most, and we bring that clarity.",
};

export const expensesClaimManagementData = {
  subtitle: "MOVE FORWARD",
  title: "BUILD A TRANSPARENT & EFFICIENT EXPENSE SYSTEM",
  desc1:
    "A well-managed expense claim process does more than reimburse employees — it strengthens trust, improves operational efficiency, and gives leadership better financial clarity.",
  desc2:
    "With Pestel & Partners, your organization gains an expense framework that’s compliant, controlled, and built for scalable growth. Let’s streamline the way your teams manage and track every claim.",
};

export const payrollHrServicesData = {
  subtitle: "YOUR WORKFORCE. OUR RESPONSIBILITY.",
  title: "BUILD A STRONGER HR & PAYROLL SYSTEM WITH US",
  desc1:
    "A strong organization is built on the confidence of its people, and that confidence begins with seamless payroll, transparent HR processes, and a system employees trust every month.",
  desc2:
    "With consistent payroll cycles, airtight compliance, and responsive assistance, we create an employee experience that feels reliable, professional, and future-ready — every single day.",
};

export const secondmentData = {
  subtitle: "BEYOND TEMPORARY STAFFING",
  title: "SECONDMENT THAT STRENGTHENS YOUR ORGANIZATION",
  desc1:
    "Secondment is more than filling temporary gaps — it’s about empowering your business with capable professionals who protect continuity, upgrade efficiency, and support your long-term goals.",
  desc2:
    "With Pestel & Partner, you gain access to trained specialists who operate with precision and accountability while blending naturally into your workplace. You stay focused on growth while we safeguard your operations with dependable, specialized talent.",
};

export const treasuryServiceData = {
  subtitle: "FUTURE-READY TREASURY",
  title: "BUILD A TREASURY THAT SUPPORTS GROWTH",
  desc1:
    "Liquidity strength determines how confidently a business operates. With structured governance, forecasting discipline, and technology-driven visibility, your treasury becomes a strategic advantage instead of a routine function.",
  desc2:
    "Our solutions help you move from reactive cash handling to proactive financial management. With Pestel & Partners, you gain the clarity, control, and resilience needed in today’s dynamic financial landscape.",
};
// STRATEGIES
export const marketResearchData = {
  subtitle: "INSIGHT THAT CREATES IMPACT",
  title: "MOVE BEYOND DATA & BUILD STRATEGIES THAT WIN",
  desc1:
    "Data is only valuable when it changes decisions. Our research goes beyond reporting trends; we interpret what those trends mean for your growth, your customers, and your competitive position.",
  desc2:
    "With Pestel & Partners, you gain a strategic research partner committed to helping you make confident, future-ready decisions backed by clarity and evidence.",
};

export const businessConsultingData = {
  subtitle: "YOUR STRATEGIC PARTNER",
  title: "BUILD A MORE EFFICIENT AND RESILIENT BUSINESS",
  desc1:
    "Meaningful change requires clarity, alignment, and the right strategic partner. We help you turn complexity into structure, challenges into opportunities, and goals into measurable outcomes.",
  desc2:
    "With Pestel & Partners, you gain more than consultants. You gain a strategic partner committed to improving your performance, refining your operations, and preparing your business for sustainable growth. All set to take your business to next level?",
};

// CORPORATE SERVICES
export const entitySetupData = {
  subtitle: "YOUR LONG-TERM CORPORATE PARTNER",
  title: "SET UP TODAY. SCALE CONFIDENTLY TOMORROW.",
  desc1:
    "Entity setup is only the beginning. As your business grows, new compliance, operational, and governance responsibilities emerge. Our team ensures your company remains compliant, structured, and prepared for expansion from day one.",
  desc2:
    "With Pestel & Partners, you gain more than incorporation support — you gain a trusted partner who stands with you through growth decisions, regulatory changes, and operational milestones.",
};

export const outsourcedFinanceRegulatoryComplianceData = {
  subtitle: "YOUR FINANCE SIMPLIFIED",
  title: "PARTNER WITH EXPERTS FOR EVERY FINANCE REQUIREMENT",
  desc1:
    "Finance and compliance are not back-office functions — they are the foundation of trust, control, and strategic clarity. Our outsourcing model helps you achieve all three without disruption, delays, or costly internal hires.",
  desc2:
    "Let us handle the operational load while you focus on scaling your business. With Pestel & Partner, you gain a reliable partner committed to accuracy, transparency, and long-term compliance excellence.",
};

export const companySecretarialData = {
  subtitle: "PARTNER WITH US",
  title: "STRENGTHEN YOUR GOVERNANCE FOUNDATION",
  desc1:
    "Sound governance protects your entity from penalties, delays, and regulatory disputes. Our company secretarial team brings structure, accuracy, and continuity—ensuring your business remains compliant in every operating year.",
  desc2:
    "With dependable support, streamlined documentation, and proactive advisory, your organization can focus on strategy and performance while we manage the complexities of corporate governance.",
};
